import React, { forwardRef } from "react";
import Typography from "../Typography";
import COLORS from "../../constants/colors";
import {
    StyledRadio,
    StyledRadioTextWrapper,
    StyledRadioWrapper,
} from "./Radio.styles";
import { RadioProps } from "./Radio.types";

const Radio = forwardRef<HTMLInputElement, RadioProps>(
    (props: RadioProps, ref) => {
        const {
            id = `radio-${props.name ?? ""}-${props.index ?? 0}`,
            index = "",
            description,
            label = "",
            value = "",
            name = "",
            onChange,
            errorMsg,
            diskPosition = "start",
            checked = false,
            disabled = false,
            labelColor,
            descriptionColor,
            fillColor = COLORS.BLUE,
            actionable = true,
        } = props;

        return (
            <StyledRadioWrapper disabled={disabled} diskPosition={diskPosition}>
                <StyledRadio
                    type="radio"
                    name={name}
                    ref={ref}
                    id={id}
                    disabled={disabled}
                    checked={checked}
                    onChange={onChange}
                    value={value}
                    fillColor={fillColor}
                    actionable={actionable}
                    diskPosition={diskPosition}
                />
                <StyledRadioTextWrapper
                    flexDirection="column"
                    alignItems="flex-start"
                    justifyContent="center"
                >
                    {!!label && (
                        <Typography
                            weight="medium"
                            as="label"
                            htmlFor={id}
                            color={labelColor}
                            size="m"
                        >
                            {label}
                        </Typography>
                    )}

                    {!!description && (
                        <Typography color={descriptionColor} size="s">
                            {description}
                        </Typography>
                    )}
                    {!!errorMsg && (
                        <Typography color={COLORS.RED} size="s">
                            {errorMsg}
                        </Typography>
                    )}
                </StyledRadioTextWrapper>
            </StyledRadioWrapper>
        );
    },
);

export default Radio;
